import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "columns", "columnSize", "gutterSize"];
import styled, { css } from 'foundations-theming/utils';
import { toPx } from '../../../utils/toPx';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../../../utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getColumnSize = (value, correction) => {
  // subtract correction from % values
  if (typeof value === 'string' && /%$/.test(value)) {
    return `calc(${value} - ${toPx(correction)})`;
  }
  // convert raw numbers to px strings
  if (typeof value === 'number') {
    return toPx(value);
  }
  // leave other string values alone
  return value;
};
const getFlexChildFallback = ({
  columns,
  columnSize,
  gutterSize
}) => css(["flex-grow:", ";flex-shrink:1;flex-basis:", ";margin-bottom:0;margin-left:", ";margin-right:0;margin-top:", ";"], typeof columnSize === 'string' && /%$/.test(columnSize) ? '0' : '1', getColumnSize(columns ? `${Math.floor(100 / columns)}%` : columnSize, gutterSize), toPx(gutterSize), toPx(gutterSize));
const getTemplateColumns = ({
  columns,
  columnSize,
  gutterSize
}) => {
  if (columns) return `repeat(${columns}, 1fr)`;
  const computedColumnSize = getColumnSize(columnSize, gutterSize);
  return `repeat(auto-fit, minmax(${computedColumnSize}, 1fr))`;
};
const StyledCardGrid = styled.div.withConfig({
  displayName: "CardGrid__StyledCardGrid",
  componentId: "sc-2sqm51-0"
})(["display:grid;grid-column-gap:", ";grid-row-gap:", ";grid-template-columns:", ";margin:0;&& > *{margin:0;}", ";"], ({
  gutterSize
}) => toPx(gutterSize), ({
  gutterSize
}) => toPx(gutterSize), getTemplateColumns, ({
  $cssStyles
}) => $cssStyles);
const CardShim = styled.div.withConfig({
  displayName: "CardGrid__CardShim",
  componentId: "sc-2sqm51-1"
})(["", ";&&{margin-top:0;}display:none;"], getFlexChildFallback);
export const CardGrid = _ref => {
  let {
      children,
      columns,
      columnSize = 295,
      gutterSize = 32
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(StyledCardGrid, Object.assign({
    $cssStyles: cssStyles,
    columnSize: columnSize,
    gutterSize: gutterSize,
    columns: columns
  }, domProps, {
    children: [children, /*#__PURE__*/_jsx(CardShim, {
      columnSize: columnSize,
      gutterSize: gutterSize,
      columns: columns
    }), /*#__PURE__*/_jsx(CardShim, {
      columnSize: columnSize,
      gutterSize: gutterSize,
      columns: columns
    }), /*#__PURE__*/_jsx(CardShim, {
      columnSize: columnSize,
      gutterSize: gutterSize,
      columns: columns
    }), /*#__PURE__*/_jsx(CardShim, {
      columnSize: columnSize,
      gutterSize: gutterSize,
      columns: columns
    }), /*#__PURE__*/_jsx(CardShim, {
      columnSize: columnSize,
      gutterSize: gutterSize,
      columns: columns
    })]
  }));
};